import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

// Shared Modules
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";

//services
import { SharedComponentsModule } from "./components/components.module";
import { HttpInterceptorService } from "./services/http-interceptor.service";

@NgModule({
	exports: [CommonModule, FormsModule, ReactiveFormsModule, SharedComponentsModule],
	declarations: [],
	imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedComponentsModule],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpInterceptorService,
			multi: true,
		},
	],
})
export class SharedModule {}
